import React, { useState } from "react";
import AddAutoIncrementLeaveBalance from "./AddAutoIncrementLeaveBalance";
import {
  formatHourAndMinute,
  getFormattedFullDate,
} from "../../../../utils/FormatDate/formaDateInMonths";

const AutoIncrementLeaveDetails = ({
  details,
  months,
  leaveTypeId,
  leaveTypeName,
  selectedYear,
  refreshDetails,
}) => {
  const [selectedMonth, setSelectedMonth] = useState(null);

  const openModal = (index) => {
    setSelectedMonth(index);
  };

  const closeModal = () => {
    setSelectedMonth(null);
    refreshDetails();
  };

  const today = new Date();
  const currentYear = today.getFullYear();
  const currentMonthIndex = today.getMonth(); // 0-based

  return (
    <>
      {months.map((month, index) => {
        const monthDetails = details.find(
          (detail) => Number(detail.updated_month) === index + 1
        );

        // ✅ FIXED YEAR-AWARE LOGIC
        const isSameYear = selectedYear === currentYear;
        const isCurrentMonth = isSameYear && index === currentMonthIndex;
        const isPreviousMonth =
          isSameYear && index === currentMonthIndex - 1;

        const isIncremented =
          monthDetails && Number(monthDetails.increment_value) > 0;

        const hasNoDataForPreviousMonth = !monthDetails;
        const canEnableButton = isPreviousMonth && hasNoDataForPreviousMonth;

        const formattedTime = monthDetails
          ? formatHourAndMinute(monthDetails.created_date)
          : "-";

        const formattedDate = monthDetails
          ? getFormattedFullDate(monthDetails.created_date)
          : "-";

        return (
          <tr key={index} className="hover:bg-gray-50">
            <td className="px-6 py-3">{month}</td>
            <td className="px-6 py-3">{selectedYear}</td>
            <td className="px-6 py-3">{formattedDate}</td>
            <td className="px-6 py-3">{formattedTime}</td>
            <td className="px-6 py-3">
              {monthDetails ? monthDetails.updated_type : "-"}
            </td>
            <td className="px-6 py-3">
              <span
                className={
                  isIncremented
                    ? "status status--green"
                    : "status status--red"
                }
              >
                {isIncremented ? "Incremented" : "Non-incremented"}
              </span>
            </td>
            <td className="px-6 py-3 text-right">
              {(isCurrentMonth || isPreviousMonth) && (
                <button
                  className={`btn px-4 py-2 rounded text-white ${
                    canEnableButton
                      ? "bg-blue-500 hover:bg-blue-600 cursor-pointer"
                      : "bg-gray-300 cursor-not-allowed opacity-50"
                  }`}
                  onClick={() => canEnableButton && openModal(index)}
                  disabled={!canEnableButton}
                >
                  Manual Increment
                </button>
              )}
            </td>
          </tr>
        );
      })}

      {selectedMonth !== null && (
        <AddAutoIncrementLeaveBalance
          open={selectedMonth !== null}
          close={closeModal}
          leaveTypeId={leaveTypeId}
          updatedMonth={selectedMonth + 1}
          refreshDetails={refreshDetails}
          leaveTypeName={leaveTypeName}
        />
      )}
    </>
  );
};

export default AutoIncrementLeaveDetails;
